// extracted by mini-css-extract-plugin
module.exports = {"collection-heading":"_21NIC"};